/**
 * 城市门店
 */

import fetch from '../utils/fetch'

// 获取省列表
const getProvinceList = () => {
  return fetch.get('/v1/region/provinces')
}

// 获取城市列表
const getCities = province => {
  return fetch.get(`/v1/region/cities`, {
    params: { province }
  })
}

// 获取城市门店
const getBoutiqueByCity = params => {
  return fetch.get(`/v1/stores`, {
    params
  })
}

// 获取粉丝群
const getDefaultTopLiveFansGroup = channel => {
  return fetch.get(`/v1/stores/top_store/${channel}`)
}

export default {
  getCities,
  getProvinceList,
  getBoutiqueByCity,
  getDefaultTopLiveFansGroup
}
